import router from '../../router';
const state = {
  all: []
}

const getters = {}

const actions = {
  getPermissions ({ commit }) {
    axios
      .get("/admin/permissions")
      .then(response => (commit('setPermissions', response.data)));
  },
}

const mutations = {
  setPermissions (state, data) {
    state.all = data.data;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
